export default function () {
  this.cancelCheckRefundStatus()
}
